/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type GetMaintenanceRecordResponse = {
  id: number;
  userId: string;
  puid: string;
  vin: string;
  sestCode: string;
  replaceOdometer: number;
  replaceDate: string;
  source: GetMaintenanceRecordResponse.source;
  isActive: boolean;
  updatedBy: string;
  updatedAt: string;
  createdBy: string;
  createdAt: string;
};
export namespace GetMaintenanceRecordResponse {
  export enum source {
    SERVICE_CENTER = 'SERVICE_CENTER',
    USER = 'USER',
    ADMIN = 'ADMIN',
  }
}

